import { configurationTypes } from '@/configuration/pages/ConfigurationPage/constants'
import configurationServices from '@/configuration/services/services'

export const servicesByConfigurationMode = {
  [configurationTypes.merchant]: {
    getPreferences: configurationServices.getMerchantPreferences,
    editPreferences: configurationServices.editMerchantPreferences,
  },
  [configurationTypes.returnsPortal]: {
    getPreferences: configurationServices.getPortalPreferences,
    editPreferences: configurationServices.editPortalPreferences,
  },
}
